'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIRadioInput = require('../input/UIRadioInput');

var _UIRadioInput2 = _interopRequireDefault(_UIRadioInput);

var _underscore = require('../utils/underscore');

var _ActiveProvider = require('../providers/ActiveProvider');

var _ActiveProvider2 = _interopRequireDefault(_ActiveProvider);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UISelectableBox = _react2.default.createClass({
  displayName: 'UISelectableBox',

  propTypes: {
    active: (0, _decorators.hidden)(_react.PropTypes.bool),
    'aria-checked': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node.isRequired,
    disabled: _react.PropTypes.bool.isRequired,
    flush: _react.PropTypes.bool,
    height: _react.PropTypes.number,
    hovered: _react.PropTypes.bool,
    innerClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onSelectedChange: _react.PropTypes.func,
    padded: _react.PropTypes.bool,
    readOnly: _react.PropTypes.bool,
    selected: _react.PropTypes.bool,
    selectionMarkLocation: _react.PropTypes.oneOf(['left', 'top-right']),
    type: _react.PropTypes.oneOf(['default', 'checkbox', 'radio']).isRequired,
    width: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      padded: true,
      readOnly: false,
      selected: false,
      type: 'default'
    };
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly;

    if (disabled || readOnly) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }
    if (type !== 'radio') {
      this.props.onSelectedChange((0, _SyntheticEvent2.default)(!this.props.selected));
    }
    (0, _Functions.callIfPossible)(this.props.onClick);
  },
  handleKeyPress: function handleKeyPress(evt) {
    if (evt.target.type === 'checkbox') return;
    var key = evt.key;
    // treat enter or space key like a click event

    if (key === 'Enter' || key === ' ') {
      evt.preventDefault();
      this.handleClick();
    }
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        __active = _props2.active,
        block = _props2.block,
        children = _props2.children,
        className = _props2.className,
        disabled = _props2.disabled,
        flush = _props2.flush,
        height = _props2.height,
        hovered = _props2.hovered,
        innerClassName = _props2.innerClassName,
        name = _props2.name,
        __onClick = _props2.onClick,
        __onSelectedChange = _props2.onSelectedChange,
        padded = _props2.padded,
        readOnly = _props2.readOnly,
        selected = _props2.selected,
        selectionMarkLocation = _props2.selectionMarkLocation,
        tabIndex = _props2.tabIndex,
        type = _props2.type,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['active', 'block', 'children', 'className', 'disabled', 'flush', 'height', 'hovered', 'innerClassName', 'name', 'onClick', 'onSelectedChange', 'padded', 'readOnly', 'selected', 'selectionMarkLocation', 'tabIndex', 'type', 'width']);

    this._id = this._id || (0, _underscore.uniqueId)('bsb-');

    return _react2.default.createElement(
      _ActiveProvider2.default,
      this.props,
      function (activeProviderProps) {
        var active = activeProviderProps.active,
            activeProviderRestProps = _objectWithoutProperties(activeProviderProps, ['active']);

        var computedClassName = (0, _classNames2.default)('uiButton', 'private-button', 'private-selectable-box', {
          'private-button--active': active,
          'private-selectable-box--selected': selected,
          'private-button--block': block,
          'disabled private-button--disabled': disabled,
          'private-selectable-box--hovered': hovered && !disabled && !readOnly,
          'private-selectable-box--padded': padded,
          'private-selectable-box--flush': flush,
          'private-selectable-box--readonly': readOnly
        }, className);

        var renderedSelectionMark = null;
        if (type !== 'default') {
          var selectionMarkClassname = (0, _classNames2.default)('private-selectable-box__selection-mark', {
            'private-selectable-box__selection-mark--left': selectionMarkLocation === 'left',
            'private-selectable-box__selection-mark--top-right': selectionMarkLocation === 'top-right'
          });

          if (type === 'checkbox') {
            renderedSelectionMark = _react2.default.createElement(
              'div',
              { className: selectionMarkClassname },
              _react2.default.createElement(_UICheckbox2.default, {
                'aria-labelledby': _this._id,
                checked: selected,
                disabled: disabled,
                innerPadding: 'none',
                name: name,
                onChange: _this.handleClick,
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                readOnly: readOnly
              })
            );
          }
          if (type === 'radio') {
            if (!name) {
              _devLogger2.default.warn({
                message: 'UISelectableBox: If type is set to radio you must provide a name',
                key: 'UISelectableBox: no name value'
              });
            }
            renderedSelectionMark = _react2.default.createElement(
              'div',
              { className: selectionMarkClassname },
              _react2.default.createElement(_UIRadioInput2.default, {
                'aria-labelledby': _this._id,
                checked: selected,
                disabled: disabled,
                name: name,
                onChange: _this.handleClick,
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                readOnly: readOnly
              })
            );
          }
        }

        var tabbableByDefault = !disabled && type === 'default';
        var defaultTabIndex = tabbableByDefault ? 0 : null;

        return (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          _react2.default.createElement(
            'div',
            _extends({}, rest, activeProviderRestProps, {
              'aria-checked': selected,
              'aria-disabled': disabled,
              className: computedClassName,
              onClick: _this.handleClick,
              onKeyPress: _this.handleKeyPress,
              role: type === 'radio' ? 'radio' : 'checkbox',
              tabIndex: typeof tabIndex === 'number' ? tabIndex : defaultTabIndex
            }),
            renderedSelectionMark,
            _react2.default.createElement(
              'div',
              {
                className: (0, _classNames2.default)('private-selectable-box__inner', innerClassName),
                id: _this._id,
                style: { height: height, width: width }
              },
              children
            )
          )
        );
      }
    );
  }
});

exports.default = (0, _Hoverable2.default)((0, _Controllable2.default)(UISelectableBox, ['selected']));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/button/UISelectableBox.js
// module id = 127
// module chunks = 3 4 5